import axios from "axios";

export const createService = async (service) => {
    const response = await axios.post(`/api/services`, { service });
    return response.data;
};

export const updateService = async service => {
    const response = await axios.put(`/api/services`, { service });
    return response.data;
};

export const getService = async id => {
    const response = await axios.get(`/api/services/${id}`);
    return response.data;
};

export const deleteService = async id => {
    const response = await axios.delete(`/api/services/${id}`);
    return response.data;
};

// export const getServicesForTenant = async tenantId => {
//     const response = await axios.get(`/api/tenant/services/${tenantId}`);
//     return response.data;
// };
